import { formatDistanceToNowStrict } from 'date-fns';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { FiMoreHorizontal } from 'react-icons/fi';
import { useEntity } from '../../../../../lib/entity';
import { useMessages } from '../../../../../lib/messages';
import { useUser } from '../../../../../lib/user';
import { parseUTC } from '../../../../../lib/utils/format';
import Button from '../../../../Button';
import Menu from '../../../../Menus/Menu';
import Modal from '../../../../Modals/Modal';
import formatDistance from './../../../../../lib/utils/formatDistance';

export default function MessageHeader({ mainThread, message, room }) {
  const router = useRouter();
  const { messageId } = router.query;
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const messagesDispatch = useMessages().dispatch;
  const removeMessage = useMessages().removeMessage;

  const user = useUser().state.user;

  const entity = useEntity().entity;

  const getCanDelete = () => {
    if (message.id) {
      if (!message.is_deleted && user.username === message.user.username) {
        return true;
      }
    }
    return false;
  };

  const canDelete = getCanDelete();

  const getMessageUser = () => {
    if (message.user_id === user.id) {
      return user;
    }
    if (message.user) {
      return message.user;
    }

    return {};
  };

  const messageUser = getMessageUser();

  const profileLink = `/${messageUser.username}`;
  const messageLink = `/${messageUser.username}/m/${message.id}`;

  const timeStamp =
    message.inserted_at &&
    formatDistanceToNowStrict(parseUTC(message.inserted_at, 'YYYY-MM-DD'), {
      locale: { formatDistance },
    });

  const showOptions = canDelete || !!messageId;

  const options = [
    ...(canDelete
      ? [
          {
            key: 'remove-message',
            name: 'Remove message',
            onClick: () => setIsOpen(true),
          },
        ]
      : []),
    ...(messageId
      ? [
          {
            key: 'view-room',
            name: 'View room',
            onClick: () => router.push(`/e/${entity.e_type}/${entity.slug}/${room.slug}`),
          },
        ]
      : []),
  ];

  const handleClose = () => {
    if (!isLoading) {
      setIsOpen(false);
    }
  };

  const onRemove = async () => {
    setIsLoading(true);
    try {
      await removeMessage(messagesDispatch, message);
      handleClose();
    } catch (error) {
      console.log('🥵 ~ error', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section
        className="profile-details"
        role="presentation"
        onKeyPress={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <Button as="a" href={profileLink} variant="clear" className="user-link">
          <span className="username">{messageUser.name}</span>
          <span className="userat">@{messageUser.username}</span>
        </Button>
        {!mainThread && (
          <>
            <span className="mx-2">·</span>
            <Button as="a" href={messageLink} variant="clear" className="time-stamp">
              {timeStamp}
            </Button>
          </>
        )}
      </section>
      {showOptions && (
        <section className="menu-container">
          <section
            role="presentation"
            onKeyPress={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            <Menu options={options} className="wrapper" position="right">
              <FiMoreHorizontal className="icon" />
            </Menu>
          </section>
        </section>
      )}

      <Modal isOpen={isOpen} onClose={handleClose} transparent>
        <section className="bg-white rounded-lg shadow-lg p-8 flex flex-col space-y-8 items-end">
          <section className="space-y-4 w-full">
            <h3 className="text-2xl font-bold">Are you sure you want to remove this message?</h3>
            <p>This cannot be undone</p>
          </section>
          <Button disabled={isLoading} onClick={onRemove} colour="danger" className="w-max">
            Remove message
          </Button>
        </section>
      </Modal>
    </>
  );
}
